import React, { Component } from "react";
import "../assets/scss/ProgressBar.css";

const DEFAULTDURATION = 10;

export default class ProgressBar extends Component {
  constructor(props) {
    // duration - basic duration of interval
    // wait - do not complete inside, wait on 99% after complition
    // completed - response succesful, set progress to 100%
    super(props);
    this.state = {
      currentProgress: 0,
      duration: props.duration || DEFAULTDURATION
    };
    this.progressRef = React.createRef();
    this.interval = null;
    this.interval = setInterval(() => {
      if (this.progressRef.current) {
        this.progressRef.current.style.width = `${(this.state.currentProgress / this.state.duration) * 10}%`;
      }
      this.setState({ currentProgress: this.state.currentProgress + 1 });
      if (props.wait && (this.state.currentProgress / this.state.duration) * 10 >= 99 ) {
        clearInterval(this.interval);
      }
      if (this.state.duration < (this.state.currentProgress / 10)) {
        clearInterval(this.interval);
      }
    }, 100);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.completed !== this.props.completed) {
        clearInterval(this.interval);
        this.progressRef.current.style.width = "100%";
        this.setState({ currentProgress: this.state.duration * 10});      
    }
  };

  render() {
    return (
      <div className="progressBar">
        <span className="progressBar-info">{`${Math.round((this.state.currentProgress / this.state.duration) * 10)}%`}</span>
        <div ref={this.progressRef} className="progressBar-progress"></div>
      </div>
    );
  }
}
